import { Pipe, PipeTransform } from '@angular/core';

import { clienteSituacoes } from '../cliente-situacao';

@Pipe({
    name: 'clienteSituacaoColor'
})
export class ClienteSituacaoColorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteSituacoes.findIndex(Situacao => Situacao.id === value);
        if (index > -1) {
            return clienteSituacoes[index].color;
        }
        return '';
    }
}
